module.exports = ".logo-bckg {\n  position: absolute;\n  top: 17%; }\n\n.login-conatiner {\n  padding-top: 20px !important; }\n"